import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getVerificationLinkStatus, setAuthRole, toggleAuthModal } from 'store/actions/auth'
import {
  navigateToRoot,
  navigateToRestorePassword,
  navigateToSignUp,
  navigateTo,
  navigateToClientDashboard,
  navigateToCPASignIn,
  navigateToLawSignIn,
  navigateToCPASignUp,
  navigateToLawSignUp,
} from 'store/actions/navigation'
import { routes } from 'constants/index'
import LogInContainer from './LogInContainer'
import { getJWTLocally } from '../../utils/auth'
import { ErrorModal } from '../../components'
import { useQuery } from '../../utils/hooks'

const LogInByRoute = props => {
  const dispatch = useDispatch()
  const query = useQuery()
  const [isRedirect] = useState(window.location.search)
  const [isOpenErrorModal, setIsOpenErrorModal] = useState(false)
  const currentUser = useSelector(state => state.auth.currentUser)
  const openUserDeletedModal = useSelector(state => state.auth.openUserDeletedModal)

  const disableClose =
    props.location.pathname === routes.SIGN_IN ||
    props.location.pathname === routes.LOGIN ||
    props.location.search.includes('redirect')
  const goToSignUp = () => {
    if (disableClose) {
      window.location.href = 'https://member.xira.com/'
    } else {
      dispatch(navigateToSignUp(props.location.search))
    }
  }

  const onUserDeletedModalClose = () => {
    dispatch(toggleAuthModal(false))
  }

  const onErrorModalClose = () => {
    setIsOpenErrorModal(false)
  }

  const closeModal = () => {
    if (disableClose) return
    dispatch(setAuthRole(''))
    dispatch(navigateToRoot())
  }

  const goToRestore = () => {
    if (disableClose) {
      const subrole = props.location.pathname === routes.CPA_SIGN_IN ? 'accountant' : 'lawyer'
      dispatch(navigateTo(`${routes.getUserPasswordResetUnauthorizedPath()}?subrole=${subrole}`))
    } else {
      dispatch(navigateToRestorePassword())
    }
  }

  const onAfterLogin = () => {
    if (!isRedirect) {
      dispatch(navigateToRoot())
    }
  }

  useEffect(() => {
    if (getJWTLocally()) {
      dispatch(navigateToClientDashboard())
    }
  }, [])

  useEffect(() => {
    const hash = query.get('hash')
    if (!hash) return
    dispatch(getVerificationLinkStatus(hash)).then(res => {
      if (!res) {
        setIsOpenErrorModal(true)
      }
    })
  }, [currentUser])

  return (
    <>
      <LogInContainer
        open
        handleClose={closeModal}
        goToSignUp={goToSignUp}
        goToRestore={goToRestore}
        disableClose={disableClose}
        onAfterLogin={onAfterLogin}
      />
      <ErrorModal
        isOpen={isOpenErrorModal}
        onClose={onErrorModalClose}
        title="Your verification link has expired."
        message="Please check the latest verification link sent to your email. If it is expired, please create a new account."
        cancelationButtonText="sign up"
        variant="primary"
      />
      <ErrorModal
        isOpen={openUserDeletedModal}
        onClose={onUserDeletedModalClose}
        title="Account is deleted"
        message="Your account was deleted"
        cancelationButtonText="ok"
        variant="primary"
      />
    </>
  )
}

export default LogInByRoute
